import Barba from 'barba.js'
import FastClick from 'fastclick'
import event from 'dom-event'
import css from 'dom-css'
import config from '../config'
import sections from '../sections'
import select from 'dom-select'
import transitionReducer from '../transitions'
import Nav from '../components/Nav'



export default class Framework {
	constructor(App) {
		this.setup()
		this.init(App)
	}
	setup() {
		// Object.assign(config, sniffer.getInfos())
		config.isDevice && FastClick.attach(config.body)
		// scrollReset()
	}
	init(App) {
		this.aboutButton = select('.button__mobile')

		this.app = new App()
		this.addEvents()
		this.initBarba()
		this.onResize()
		new Nav()
		// new Preloader()
		// new Grid(document.querySelector('.grid'))

	}

	addEvents() {

		window.addEventListener('resize', this.onResize)
		Barba.Dispatcher.on('linkClicked', this.onLinkClicked)
		Barba.Dispatcher.on('initStateChange', this.onInitStateChange)
		Barba.Dispatcher.on('newPageReady', this.onNewPageReady)
		Barba.Dispatcher.on('transitionCompleted', this.onTransitionCompleted)

	}

	initBarba() {

		sections.map(view => view.barba.init())
		// Barba.Utils.xhrTimeout = 0
		Barba.Prefetch.init()
		Barba.Pjax.Dom.wrapperId = 'content'
		Barba.Pjax.Dom.containerClass = 'page'
		Barba.Pjax.getTransition = transitionReducer
		Barba.Pjax.start()

	}

	onResize = () => {
		config.width = window.innerWidth
		config.height = window.innerHeight
		this.traverse('onResize', config.width, config.height)
	}

	onLinkClicked = (...args) => {
		this.traverseApp('onLinkClicked', ...args)
	}

	onInitStateChange = (...args) => {
		css(config.html, {
			pointerEvents: 'none'
		})
		this.traverseApp('onInitStateChange', ...args)
	}

	onNewPageReady = (currentStatus, ...args) => {

		this.updateBodyClass()
		this.traverseApp('onNewPageReady', ...args)

	}

	onTransitionCompleted = (...args) => {
		css(config.html, {
			pointerEvents: 'auto'
		})
		this.traverseApp('onTransitionCompleted', ...args)
	}

	updateBodyClass() {
		config.body.classList.add(
			`is-${Barba.Pjax.History.currentStatus().namespace}`,
		)
		if (Barba.Pjax.History.prevStatus()) {
			config.body.classList.remove(
				`is-${Barba.Pjax.History.prevStatus().namespace}`,
			)
		}
	}

	traverseApp = (fn, ...args) => {
		typeof this.app[fn] === 'function' && this.app[fn](...args)
	}

	traverseViews = (fn, ...args) => {
		sections
			.filter(
				view =>
					Barba.HistoryManager.currentStatus() &&
				view.barba.namespace === Barba.HistoryManager.currentStatus().namespace,
			)
			.map(view => typeof view.barba[fn] === 'function' && view.barba[fn](...args))
	}

	traverse = (fn, ...args) => {
		this.traverseApp(fn, ...args)
		this.traverseViews(fn, ...args)
	}
}